<template>
  <div v-if="artwork"
       class="col-12 row auctions__row no-gutters justify-content-center">
    <div class="col-sm-1 d-flex flex-column justify-content-between">
      <ArtworkCatalogNumber :catalogNumber="artwork.catalogNumber" class="default-cursor" />
    </div>
    <div class="col-sm-11 details__desc pt-0 pl-lg-2">
      <ArtworkDetails :artwork="artwork"
                      :index="index"
                      :finished="false"/>
    </div>
  </div>
</template>

<script>
  import ArtworkCatalogNumber from '@/shared/components/artwork_catalog_number';
  import ArtworkDetails from './artwork_details';

  export default {
    name: 'IncomingArtworkRow',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    components: {
      ArtworkDetails,
      ArtworkCatalogNumber,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/incoming_artwork_row.vue?792283b6